// extracted by mini-css-extract-plugin
export var active = "_hj-7";
export var blink = "_hj-8";
export var dropDownSelector = "_hj-4";
export var dropDownWrapper = "_hj-3";
export var fakeCursor = "_hj-6";
export var fontSizeButton = "_hj-9";
export var formQuillEditor = "_hj-0";
export var pressed = "_hj-a";
export var qlBlank = "_hj-1";
export var textFormattingToolbar = "_hj-2";
export var textToolbarOption = "_hj-5";